/* NOTE: This mimics what we do in webapp and links to our custom version of
React -- this was not added with npm */
module.exports = require("react").__internalAddons.createFragment;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-create-fragment/index.js
 ** module id = 168
 ** module chunks = 0 2
 **/